<template>
  <v-layout
    mb-8
    wrap
  >
    <v-flex
      mt-4
      xs12
      md12
    >
      <v-text-field
        v-model.trim="form.gtm_tag"
        :error-messages="GtmTagErrors"
        name="whitelabel-gtmTag"
        :label="$t('whitelabel.gtmTag')"
        @input="$v.form.gtm_tag.$touch()"
        @blur="$v.form.gtm_tag.$touch()"
      />
    </v-flex>
    <v-flex
      md12
    >
      <v-checkbox
        v-model="use_aff_plan"
        color="primary"
        @change="!use_aff_plan ? (form.aff_plan_id = null) : ''"
      >
        <template v-slot:label>
          <b>{{ $t('whitelabel.useAffPlan') }}</b>
        </template>
      </v-checkbox>
      <v-select
        v-show="use_aff_plan"
        v-model.trim="form.aff_plan_id"
        class="mt-3"
        :items="whiteLabelAffPlans"
        :item-text="'name'"
        :item-value="'id'"
        :label="$t('whitelabel.affPlan')"
        name="aff-plan"
      >
        <template
          slot="selection"
          slot-scope="data"
        >
          <v-list-item-content>
            <v-list-item-title v-html="data.item.name" />
          </v-list-item-content>
        </template>
        <template
          slot="item"
          slot-scope="data"
        >
          <v-list-item-content>
            <v-list-item-title v-html="data.item.name" />
            <small class="text-neutral">{{ data.item.description }}</small>
          </v-list-item-content>
        </template>
      </v-select>
    </v-flex>
    <v-flex
      v-show="!use_aff_plan"
      xs12
    >
      <v-divider />
    </v-flex>
    <v-flex>
      <v-checkbox
        v-model="form.expanded_display_balance"
        :label="$t('whitelabel.expandedBalance')"
        color="primary"
      />
      <v-checkbox
        v-model="form.show_ref_link_only_after_purchase"
        :label="$t('whitelabel.showRefLink')"
        color="primary"
      />
      <v-checkbox
        v-model="form.signup_reflink_only"
        :label="$t('whitelabel.signupReflink')"
        color="primary"
      />
      <v-checkbox
        v-model="form.ref_button_left_menu"
        :label="$t('whitelabel.buttonLeftmenu')"
        color="primary"
      />
      <v-checkbox
        v-model="form.show_ref_profile"
        :label="$t('whitelabel.showRefProfile')"
        color="primary"
      />
      <v-checkbox
        v-model="form.show_sponsor_profile"
        :label="$t('whitelabel.showSponsorProfile')"
        color="primary"
      />
      <v-checkbox
        v-model="form.show_ref_tree"
        :label="$t('whitelabel.showRefTree')"
        color="primary"
      />
      <v-checkbox
        v-model="form.require_first_lastname"
        :label="$t('whitelabel.requireFirstLastname')"
        color="primary"
      />
      <v-checkbox
        v-model="form.require_confirm_password"
        :label="$t('whitelabel.requireConfirmPassword')"
        color="primary"
      />
      <v-checkbox
        v-model="form.require_telegram"
        :label="$t('whitelabel.requireConfirmTelegram')"
        color="primary"
      />
      <v-checkbox
        v-model="form.allow_edit_name"
        :label="$t('whitelabel.allowEditName')"
        color="primary"
      />
    </v-flex>
  </v-layout>
</template>

<script>

const gtmKey = key =>{
  if (key == null || key == "") {
    return true;
  }
  const re = /GTM-[0-9A-Z]+|G-[0-9A-Z]{10,}$/
  return re.test(key);
}

import { validationMixin } from 'vuelidate';
import {
  required
} from "vuelidate/lib/validators";

import WHITE_LABEL_AFF_PLANS_QUERY from '@/graphql/queries/WhiteLabelAffPlans.gql';

export default {
  name: 'WhiteLabelMarketing',
  mixins: [validationMixin],
  props: {
    editForm: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      use_aff_plan: false,
      form: {
        gtm_tag: '',
        aff_plan_id: null,
        signup_reflink_only: false,
        ref_button_left_menu: false,
        show_ref_profile: false,
        show_sponsor_profile: false,
        show_ref_tree: false,
        require_first_lastname: false,
	      require_confirm_password: false,
        require_telegram: false,
	      allow_edit_name: false,
        show_ref_link_only_after_purchase: false,
        expanded_display_balance: false
      },
    };
  },
  validations() {
    return {
      form: this.rules,
    };
  },
  computed: {
    telegram_support_id: {
      set(val) {
        this.form.telegram_support_id = val.replace('@', '');
      },
      get() {
        return this.form.telegram_support_id;
      },
    },
    rules() {
      var form = {
        gtm_tag: {
          gtmKey
        }
      };
      return form;
    },
    GtmTagErrors() {
      const errors = [];
      if (!this.$v.form.gtm_tag.$dirty) return errors;
      !this.$v.form.gtm_tag.gtmKey &&
        errors.push(this.$t("whitelabel.invalidGtm"));
      return errors;
    },
  },
  watch: {
    editForm(value) {
      if (value) {
        this.form = {
          aff_plan_id: this.editForm.aff_plan
            ? parseInt(this.editForm.aff_plan.id)
            : null,
          signup_reflink_only: this.editForm.signup_reflink_only,
          ref_button_left_menu: this.editForm.ref_button_left_menu,
          show_ref_profile: this.editForm.show_ref_profile,
          show_sponsor_profile: this.editForm.show_sponsor_profile,
          show_ref_tree: this.editForm.show_ref_tree,
          require_first_lastname: this.editForm.require_first_lastname,
	        require_confirm_password: this.editForm.require_confirm_password,
          require_telegram: this.editForm.require_telegram,
	        allow_edit_name: this.editForm.allow_edit_name,
          show_ref_link_only_after_purchase: this.editForm.show_ref_link_only_after_purchase,
          expanded_display_balance: this.editForm.expanded_display_balance,
          gtm_tag: this.editForm.gtm_tag || ''
        };
        if (this.form.aff_plan_id != null) {
          this.use_aff_plan = true;
        } else {
          this.use_aff_plan = false;
        }
      }
    },
  },
  apollo: {
    whiteLabelAffPlans: {
      query() {
        return WHITE_LABEL_AFF_PLANS_QUERY;
      },
    },
  },
  methods: {
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('saveForm', this.form);
      }
    },
  },
};
</script>

<style lang="scss"></style>
